import { createSelector } from 'reselect';

import { PATHS } from '@common/routes';
import { filterMenuItemsByFlippers, filterMenuItemsByUserId } from '@common/utils/filterMenuItems';
import { isSourceUserAndSelectedFamilyMemberSimilarSelector } from '@modules/MyHealth/store';
import { FlipperType, HideFlippersEnum } from '@modules/flippers';
import { getIsRestrictedSelector } from '@modules/userProfileData';

import { TAB_LIST, VIEW_APPOINTMENTS, SCHEDULE_AND_VIEW_APPOINTMENTS } from '../constants';

export const mainMenuOpenSelector = (state: RootState) => state.header.mainMenuOpen;
export const getFlippersSelector = (state: RootState) => state.flippers.flippers;
export const getHcbbUrlSelector = (state: RootState) => state.userProfile.hcbbUrl;

export const getVisibleMenuItems = createSelector(
  getFlippersSelector,
  getHcbbUrlSelector,
  getIsRestrictedSelector,
  isSourceUserAndSelectedFamilyMemberSimilarSelector,
  (flippers, hcbbUrl, isRestricted, isSourceUserAndSelectedFamilyMemberSimilar) => {
    const getFlipperValue = (flipper: FlipperType): boolean => flippers[flipper] ?? false;
    const filteredMenuItems = filterMenuItemsByFlippers(
      filterMenuItemsByUserId(TAB_LIST, isSourceUserAndSelectedFamilyMemberSimilar),
      getFlipperValue,
    );
    const hideAppointmentButtons = getFlipperValue(HideFlippersEnum.hide_appointment_buttons);

    return filteredMenuItems.map((menuItem) => {
      if (menuItem.to === PATHS.RESOURCES.ROOT && menuItem.subMenuItems) {
        return {
          ...menuItem,
          subMenuItems: menuItem.subMenuItems.filter(
            (subMenuItem) => !(subMenuItem.to === PATHS.RESOURCES.BLUEBOOK && !hcbbUrl),
          ),
        };
      }

      if (menuItem.to === PATHS.APPOINTMENTS.ROOT && menuItem.subMenuItems) {
        let subMenuItems = [SCHEDULE_AND_VIEW_APPOINTMENTS, ...menuItem.subMenuItems];

        if (hideAppointmentButtons) {
          subMenuItems = [VIEW_APPOINTMENTS, ...menuItem.subMenuItems];
        }

        return {
          ...menuItem,
          subMenuItems: subMenuItems.filter((subMenuItem) =>
            subMenuItem.to === PATHS.APPOINTMENTS.SCHEDULE_APPOINTMENT ? !isRestricted : true,
          ),
        };
      }

      return menuItem;
    });
  },
);
